import React from 'react';
import { usePage } from '@inertiajs/react';
import MainMenuItem from '@/Shared/MainMenuItem';

export const MainMenu = ({ className }) => {
	const { user } = usePage().props;
	const { is_wrap_group = false } = user;

	const items = [
		{
			text: 'Dashboard',
			link: 'dashboard.index',
			icon: 'font-awesome-dashboard'
		},
		{
			text: 'Claim History',
			link: 'claims.index',
			icon: 'font-awesome-list-alt'
		},
		{
			text: 'My Account',
			link: 'patient-my-account.index',
			icon: 'font-awesome-user'
		},
		{
			text: 'Communications',
			link: 'contact.index',
			icon: 'font-awesome-envelope'
		},
		{
			text: 'Log Out',
			link: 'logout.index',
			icon: 'font-awesome-arrow-circle-o-left'
		}
	];

	if (!is_wrap_group) {
		items.splice(3, 0, {
			text: 'Drug Price Lookup',
			link: 'drug-lookup.index',
			icon: 'font-awesome-dollar'
		});
	}

	return (
		<div className={className}>
			{items.map((item, index) => {
				return (
					<MainMenuItem
						key={index}
						text={item.text}
						link={item.link}
						icon={item.icon}
						containerClasses={item?.containerClasses || ''}
						// newLabel={item.link === 'drug-lookup.index'}
					/>
				);
			})}
		</div>
	);
};

export default MainMenu;
